import React from "react";
import { ButtonGroup, Button, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router";
import {styled} from "@mui/material/styles";


const RegisterBlackTitle = styled(Typography)(() => ({
    color: '#000000',
    fontWeight: 500,
}));

const RegisterBlackDescription = styled(Typography)(() => ({
    color: '#000000',
    fontWeight: 400,
    marginBottom: '1em',
}));

interface RegisterSubMenuProps {
    show: boolean;
    onClick?: () => void;
}

const RegisterSubMenu = (props: RegisterSubMenuProps) => {
    const { show, onClick } = props;
    const history = useNavigate();

    return <ButtonGroup
        variant="text"
        className={show ? "ss-register-submenu-visible" : "ss-submenu-hidden"}
    >
        <Button onClick={() => {
            onClick && onClick();
            history(`/buyer-signup`)
        }} className="ss-register-customer-button-container">
            <Grid container className="ss-register-submenu-item ss-register-customer-button">
                <RegisterBlackTitle variant="body1">As A Buyer</RegisterBlackTitle>
                <RegisterBlackDescription variant="body2">Reserve available parking and storage space.</RegisterBlackDescription>
                <Typography variant="body2" className='ss-register-submenu-caps'>REGISTER</Typography>
            </Grid>
        </Button>
        <Button onClick={() => {
            onClick && onClick();
            history(`/supplier-signup`)
        }}>
            <Grid container className="ss-register-submenu-item ss-register-partner-button">
                <RegisterBlackTitle variant="body1">As A Supplier</RegisterBlackTitle>
                <RegisterBlackDescription variant="body2">List your location for truck and container parking.</RegisterBlackDescription>
                <Typography variant="body2" className='ss-register-submenu-caps'>LEARN MORE</Typography>
            </Grid>
        </Button>
    </ButtonGroup>
        ;
}

export default RegisterSubMenu;
